
import { searchUsers, editUser, getUsers } from '@/services/endpoints/users';


export default {
    async getPatients({ commit }, patient) {
        try {
          let res = await searchUsers(patient);
          if (res.data) {
            commit('SET_PATIENTS', res.data.data)
            commit('SET_TOTAL', res.data.total)
            return res.data.data;
          }
        } catch (err) {
          throw new Error(err);
        }
      },
      async getReferralWays({ commit }) {
        try {
          let res = await getReferralWays();
          if (res.data) {
            commit("SET_REFERRAL_WAYS", res.data);
            return res.data;
          }
        } catch (err) {
          throw new Error(err);
        }
      },
      async editPatient({ commit, getters }, payload) {
        try {
          let res = await editUser(payload, getters.patientToEdit._id);
          if (res.data) {
            return res.data;
          }
        } catch (err) {
          throw new Error(err);
        }
      },
  async searchPatients({commit}, patient) {
    try {
      let res = await searchUsers(patient);
      if (res.data.data) {
        commit('SET_PATIENTS', res.data.data)
        commit('SET_TOTAL', res.data.total)
        return res.data.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
}